/* Tear-offs (2026-10-02): the demo and the quick add for sections/tear-offs.liquid.
   Demo: films stacked over a riding scene (the last .to__film is the top one). "Ride through mud" splashes the top layer, "Tear off the top layer" peels it away
   (a short animation; none under prefers-reduced-motion) and the layer underneath is clean. Nothing autoplays. Quick add: POST cart/add.js, then the cart drawer
   events the other add buttons use (cart-drawer:adding / :open / :add-failed). Without JS the demo is hidden and the rest of the section still reads. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function root(path) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r + path;
  }

  function initDemo(section) {
    var demo = section.querySelector('[data-to-demo]');
    if (!demo) return;
    var films = [].slice.call(demo.querySelectorAll('[data-to-film]'));
    var tear = demo.querySelector('[data-to-tear]');
    var splash = demo.querySelector('[data-to-splash]');
    var reset = demo.querySelector('[data-to-reset]');
    var count = demo.querySelector('[data-to-count]');
    var total = films.length;
    var left = total;
    var tpl = demo.getAttribute('data-count') || '[n]';
    var empty = demo.getAttribute('data-empty') || '';
    section.classList.add('to--js');

    function top() { return films[left - 1]; }

    function update() {
      count.textContent = left ? tpl.replace('[n]', String(left)) : empty;
      tear.disabled = !left;
      splash.disabled = !left;
      reset.hidden = left === total;
    }

    tear.addEventListener('click', function () {
      var f = top();
      if (!f) return;
      left--;
      if (reduce) {
        f.hidden = true;
      } else {
        f.classList.add('is-peeling');
        f.addEventListener('animationend', function () { f.hidden = true; }, { once: true });
      }
      update();
    });

    splash.addEventListener('click', function () {
      var f = top();
      if (!f) return;
      f.classList.remove('is-splashing');
      void f.offsetWidth; // restart the animation when it is pressed again
      f.classList.add('is-muddy');
      if (!reduce) f.classList.add('is-splashing');
    });

    reset.addEventListener('click', function () {
      films.forEach(function (f) { f.hidden = false; f.classList.remove('is-peeling', 'is-splashing', 'is-muddy'); });
      films[films.length - 1].classList.add('is-muddy');
      left = total;
      update();
      tear.focus();
    });

    update();
  }

  function initAdd(section) {
    var btn = section.querySelector('[data-to-add]');
    var status = section.querySelector('[data-to-status]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-adding') || label;
      if (status) status.textContent = '';
      document.dispatchEvent(new CustomEvent('cart-drawer:adding'));
      fetch(root('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      }).catch(function () {
        document.dispatchEvent(new CustomEvent('cart-drawer:add-failed'));
        if (status) status.textContent = btn.getAttribute('data-error') || '';
      }).then(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-to]')).forEach(function (s) {
      if (s.__toReady) return;
      s.__toReady = true;
      initDemo(s);
      initAdd(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
